// "IA contact: Ms Tan · tan@client.com [Change]" — Internal Audit's own contact person for a client (clients.ia_contact_*,
// IA_CONTACT.sql). Every Internal Audit email goes here; when none is set, the client's main contact is used and shown
// with a grey "(main contact)". The main (bizSAFE) contact itself is never changed from here.
import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { toast, failed } from '../lib/toast'

// Who Internal Audit emails: the IA contact, else the main contact.
export const iaContactOf = (c) => c?.ia_contact_email
  ? { name: c.ia_contact_name || '', email: c.ia_contact_email, phone: c.ia_contact_phone || '', isMain: false }
  : { name: c?.contact_name || '', email: c?.contact_email || '', phone: c?.contact_phone || '', isMain: true }

export default function IAContactLine({ clientId, label = 'IA contact', onSaved }) {
  const [c, setC] = useState(null)
  const [edit, setEdit] = useState(null)
  const [saving, setSaving] = useState(false)

  async function load() {
    const { data } = await supabase.from('clients').select('id, contact_name, contact_email, contact_phone, ia_contact_name, ia_contact_email, ia_contact_phone').eq('id', clientId).maybeSingle()
    setC(data || null)
  }
  useEffect(() => { if (clientId) load() }, [clientId])

  async function save() {
    const email = (edit.email || '').trim()
    if (email && !/^\S+@\S+\.\S+$/.test(email)) return toast('Check the email address', 'warning')
    setSaving(true)
    const { error } = await supabase.from('clients').update({ ia_contact_name: (edit.name || '').trim() || null,
      ia_contact_email: email || null, ia_contact_phone: (edit.phone || '').trim() || null }).eq('id', clientId)
    setSaving(false)
    if (error) return failed("Couldn't save", error.message)
    toast('IA contact saved', 'success', { detail: email ? 'Internal Audit emails now go to this person.' : 'Internal Audit emails go to the main contact.' })
    setEdit(null); await load(); onSaved && onSaved()
  }

  if (!c) return null
  const ia = iaContactOf(c)
  if (edit) return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', fontSize: 13 }}>
      <input placeholder="Name" value={edit.name} onChange={e => setEdit(x => ({ ...x, name: e.target.value }))} style={{ flex: '1 1 140px' }} />
      <input placeholder="Email" type="email" value={edit.email} onChange={e => setEdit(x => ({ ...x, email: e.target.value }))} style={{ flex: '1 1 180px' }} />
      <input placeholder="Phone" value={edit.phone} onChange={e => setEdit(x => ({ ...x, phone: e.target.value }))} style={{ flex: '1 1 110px' }} />
      <button className="primary sm" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      <button className="sm" onClick={() => setEdit(null)}>Cancel</button>
    </div>
  )
  return (
    <div style={{ fontSize: 13 }}>
      <span style={{ color: 'var(--text2)' }}>{label}: </span>
      {ia.name || '—'}{ia.email ? ` · ${ia.email}` : ''}{ia.phone ? ` · ${ia.phone}` : ''}
      {!ia.email && <span style={{ color: 'var(--danger)' }}> No email</span>}
      {ia.isMain && <span style={{ color: 'var(--text3)' }}> (main contact)</span>}
      <button className="sm" style={{ marginLeft: 8 }} onClick={() => setEdit({ name: c.ia_contact_name || '', email: c.ia_contact_email || '', phone: c.ia_contact_phone || '' })}>Change</button>
    </div>
  )
}
